
export const BASE_CLS = 'scheduled-paxcgo-adder';